<template>
  <div class="automation-wraper">
    <p class="automation-wraper-p">出行要求和安全协议</p>
    <div class="automation-wraper-content">
      <el-tabs
        v-model="activeTab"
        :tab-position="tabPosition"
        @tab-click="handleClick"
        class="tabs"
      >
        <el-tab-pane v-for="item in tabPane" :key="item.id" :name="item.id">
          <div
            class="tabs-label"
            :class="{
              'is-active': activeTab == item.id,
            }"
            slot="label"
          >
            {{ item.name }}
          </div>
          <div class="tabs-info">
            <p class="tabs-title">{{ detail.title }}</p>
            <div v-html="detail.content" class="tabs-content"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <v-loading :active="loading" />
  </div>
</template>

<script>
import {
  getRequirementsAgreements,
  getRequirementsAgreementsDetail,
} from "@/services/company";

export default {
  name: "FrontPcRequirementsAgreements",
  layout: "Main",
  auth: false,
  data() {
    return {
      tabPosition: "left",
      tabPane: [],
      activeTab: "",
      detail: {},
      loading: false,
    };
  },
  mounted() {
    document.title = '资源采购 - 上船吧'
    this.getRequirementsList();
  },

  methods: {
    async getRequirementsList() {
      this.loading = true;
      let { code, data } = await getRequirementsAgreements();
      if (code && code == 10000) {
        this.tabPane = data;
        this.loading = false;
      } else {
        this.$message({
          type: "error",
          text: msg,
        });
      }
      let res = await getRequirementsAgreementsDetail({
        id: data[0].id,
      });
      this.detail = res.data;
      this.activeTab = data[0].id;
    },
    handleClick(tab) {
      const checkPane = this.tabPane.filter((item) => item.id === tab.paneName);
      this.getReAgreementsDetail(checkPane[0].id);
    },
    async getReAgreementsDetail(id) {
      let { code, data } = await getRequirementsAgreementsDetail({ id: id });
      if (code && code == 10000) {
        this.detail = data;
        this.loading = false;
      } else {
        this.$message({
          type: "error",
          text: msg,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.automation-wraper {
  color: #1f2129;
  margin-bottom: 35px;
  min-height: calc(100vh - 458px);
}
.automation-wraper-p {
  margin: 15px 0 18px;
}
.automation-wraper-content {
  width: 1100px;
  background-color: $color-white;
  padding: 25px 15px 46px 0px;
}
.automation-wraper-content .tabs {
  color: #1f2129;
}
.automation-wraper-content .tabs ::v-deep .el-tabs__active-bar {
  background-color: transparent;
}
.automation-wraper-content .tabs ::v-deep .el-tabs__nav-wrap.is-left:after {
  width: 1px;
}
.automation-wraper-content .tabs-info {
  margin-left: 20px;
}
.automation-wraper-content .tabs-label {
  color: #1f2129;
  padding: 0px 20px 0px 12px;
  font-weight: normal;
  width: 184px;
  background: none;
  text-align: left;
  border: none;
}
.automation-wraper-content .tabs-label.is-active {
  background: $color-primary;
  border-radius: 4px 4px 4px 4px;
  width: 184px;
  height: 36px;
  line-height: 36px;
  color: #fff;
}
.automation-wraper-content .tabs-title {
  font-size: 20px;
  font-weight: bold;
}
.automation-wraper-content ::v-deep .tabs-content h1, .automation-wraper-content ::v-deep .tabs-content h2, .automation-wraper-content ::v-deep .tabs-content h3, .automation-wraper-content ::v-deep .tabs-content h4, .automation-wraper-content ::v-deep .tabs-content h5, .automation-wraper-content ::v-deep .tabs-content h6 {
  margin-bottom: 0.75rem;
}
.automation-wraper-content ::v-deep .tabs-content {
  margin-top: 20px;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.automation-wraper-content ::v-deep .tabs-content a {
  pointer-events: none;
}
.automation-wraper-content ::v-deep .tabs-content h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.automation-wraper-content ::v-deep .tabs-content h2 {
  font-size: 1.625rem;
}
.automation-wraper-content ::v-deep .tabs-content h3 {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.automation-wraper-content ::v-deep .tabs-content h4 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.automation-wraper-content ::v-deep .tabs-content ul, .automation-wraper-content ::v-deep .tabs-content ol {
  list-style-position: outside;
  margin-bottom: 1.25rem;
  margin-top: 0px;
  padding-left: 1.25rem;
}
.automation-wraper-content ::v-deep .tabs-content ul {
  list-style-type: disc;
}
.automation-wraper-content ::v-deep .tabs-content p {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
</style>
